import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useThemeStore } from '../stores/themeStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const store = useThemeStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(store).dark ? 'footerContainer' : 'footerContainerLight')
  }, " Copyright Adam Ryan " + _toDisplayString(new Date().getFullYear()), 3))
}
}

})